import React from "react";
import { Link } from "react-router-dom"; // 👈 import Link
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        {/* Logo + Name */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src="images/ptc.png"
            alt="PTC Logo"
            width="40"
            height="40"
            className="me-2"
          />
          <span>
            <strong>PTC</strong> - Ptrans and Control
          </span>
        </Link>

        {/* Toggler for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link active" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="productsDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Products
              </Link>
              <ul className="dropdown-menu" aria-labelledby="productsDropdown">
                <li>
                  <Link className="dropdown-item" to="/level">
                    Level
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/pressure">
                    Pressure
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/flow">
                    Flow
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/temperature">
                    Temperature
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/analytical">
                    Analytical
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/indicator">
                    Indicator
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/solutions">
                Solution
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/industry">
                Industry
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/careers">
                Careers
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
